import Vue from "vue";
import Component from "vue-class-component";
import { modalHelper, DataItem } from "@/components/modal/modalHelper";
import { Async } from "@/utils/AsyncDecorators";
import { Watch, Prop } from "vue-property-decorator";
import { usersStore } from "@/modules/Utenti/store/users.store";
import { applyArrayChanges } from "@/utils/ApplyArrayChange";
import { accountService } from '@/services/accountService';
import { toastHelper } from '@/helpers/ToastHelper';

@Component({ components: {} })
export default class ChangePassword extends Vue {

  show: any = {
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  }

  value: server.account.changePassword = {
    newPassword: "",
    confirmPassword: "",
    oldPassword: ""
  };

  mounted() {
   setTimeout(this.validateForm, 2000); 
  }

  formIsValid: boolean = false;
  validateForm() {
    this.formIsValid = (this.$refs.form && (this.$refs.form as any).checkValidity())
  }

  save() {
    if (this.value.newPassword == this.value.confirmPassword) {
      accountService.ChangePassword(this.value)
        .then(result => {
          toastHelper.success("La password è stata cambiata con successo.<br/>Accedi al servizio utilizzando le nuove credenziali impostate!");
          setTimeout(() => {
            this.goTo("home");
          }, 3600);
        }, (err => {
          toastHelper.error("Si è verificato un errore nel reset della password dell'account.");
        }));
    } else {
      toastHelper.error("Le password non corrispondono.");
      this.value.confirmPassword = "";
    }
  }

  goTo(name) {
    this.$router.push({ name: name });
  }
}